import type { UnionTypeLibelle } from '../../../techniques'

export const NatureContrat = ['Cdd', 'CddIntertion', 'Cdi', 'TravailTemporaireCdi', 'TravailTemporaire'] as const
export type NatureContrat = (typeof NatureContrat)[number]

export const NatureContratLibelle: UnionTypeLibelle<NatureContrat> = {
  Cdd: 'Contrat à Durée Déterminée',
  CddIntertion: 'Contrat à Durée Déterminée insertion',
  Cdi: 'Contrat à Durée Indéterminée',
  TravailTemporaire: 'Contrat Travail Temporaire',
  TravailTemporaireCdi: 'Contrat à Durée Indéterminée Intérimaire',
} as const

export const NatureContratTTInterimaire: ReadonlyArray<
  Extract<NatureContrat, 'TravailTemporaireCdi' | 'TravailTemporaire'>
> = ['TravailTemporaireCdi', 'TravailTemporaire'] as const

export const NatureContratTTPermanent: ReadonlyArray<Extract<NatureContrat, 'Cdd' | 'Cdi'>> = ['Cdd', 'Cdi'] as const

export const NatureContratHorsTT: ReadonlyArray<Extract<NatureContrat, 'Cdd' | 'Cdi' | 'CddIntertion'>> = [
  'Cdd',
  'Cdi',
  'CddIntertion',
] as const

export type NatureContratTTInterimaire = (typeof NatureContratTTInterimaire)[number]
export type NatureContratTTPermanent = (typeof NatureContratTTPermanent)[number]
export type NatureContratHorsTT = (typeof NatureContratHorsTT)[number]
